import * as React from 'react';

export const DeezerIsologo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg width="23" height="15" viewBox="0 0 23 15" {...props}>
    <rect y="12" width="5" height="3" />
    <rect x="12" y="12" width="5" height="3" />
    <rect x="12" y="8" width="5" height="3" />
    <rect x="6" y="12" width="5" height="3" />
    <rect x="6" y="8" width="5" height="3" />
    <rect x="6" y="4" width="5" height="3" />
    <rect x="18" y="12" width="5" height="3" />
    <rect x="18" y="8" width="5" height="3" />
    <rect x="18" width="5" height="3" />
    <rect x="18" y="4" width="5" height="3" />
  </svg>
);

export default DeezerIsologo;
